import type { FindTasksInput } from '@travel-planner/shared/schemas/tasks';
import { trpc } from '@/shared/api/trpc';

type UseListTasksOptions = {
  enabled?: boolean;
};

export const useListTasks = (
  input: FindTasksInput,
  options: UseListTasksOptions = {}
) => trpc.tasks.list.useQuery(input, { enabled: options.enabled ?? true });
